import React from 'react';
import * as styles from './base.scss';
export default ({ text }) => React.createElement("div", { className: styles.separator }, text);
